import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableProdMode } from '@angular/core';

import * as Sentry from '@sentry/angular-ivy';

import { AppModule } from './app/app.module';
import { environment } from '@environments';
import { BrowserProfilingIntegration } from '@sentry/angular-ivy';

Sentry.init({
  dsn: environment.sentry.dsn,
  environment: environment.name,
  integrations: [
    new Sentry.BrowserTracing({
      routingInstrumentation: Sentry.routingInstrumentation,
    }),
    new BrowserProfilingIntegration(),
    Sentry.replayIntegration(),
  ],

  tracePropagationTargets: ['localhost', /\.mypaymash\.com/],
  tracesSampleRate: 1.0,
  profilesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

enableProdMode();
platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
